module.exports = __webpack_public_path__ + "img/Question.5a3449b4.svg";